import {formTrackingDataLayer} from './form-tracking-analytics';

window.formTracking = window.formTracking? window.formTracking : {};

window.formTracking.test = (xhr) => {
  for (let index = 0; index < xhr[0].elements.length; index++) {
    const element = xhr[0].elements[index];
      if (element.value) {
        if (element.dataset.scFieldName && (element.type != "radio" || element.dataset.val === "true")){
          // todo: filter to required (from settings item) element.dataset.scFieldTitle / element.value pairs
        }
      }
  }
};

window.formTracking.trackForms = function() {
  if (window.formTracking.forms) {
    window.formTracking.forms.split('&').forEach((pair) => {
      if (window.formTracking.forms.split('=').length === 2) {
        const id = window.formTracking.forms.split('=')[0];
        formTrackingDataLayer(window.formTracking.forms.split('=')[1]);    
      }
    });
    window.formTracking.forms = null;
  }
}

document.addEventListener("DOMContentLoaded", function() {
  window.formTracking.trackForms();

  // Remove the standard JQuery submit event listener when using ajax unobtrusive because it causes a conflict on Safari.
  var $form = $("form[data-ajax='true'");
  if ($form.length) {
    $form.unbind('submit');
  }
});
